export default __webpack_public_path__ + "static/media/cloudflare.dd574982.svg";